/*
 *   Copyright (c) 2026 Propally.Inc
 *   All rights reserved.
 */

import { PropallyApiFactory } from "@/module/CustomApiFactory";

import { PrivacyPolicy, PrivacyPolicyConsentStatusEnum } from "./generated/api";

// success で判別するユニオン型（success チェック後は is_agreed が boolean に絞り込まれる）
type GetConsentResponse =
  | {
      success: true;
      is_agreed: boolean;
      // policy は is_agreed=false のときのみ同梱される契約（同意済み・機能OFF=現行版なしのときは
      // is_agreed: true のみが返り、policy キー自体が含まれないため null に正規化する）。
      policy: PrivacyPolicy | null;
    }
  | { success: false; error: string };

export const getPrivacyPolicyConsent = async (): Promise<GetConsentResponse> => {
  const fp = PropallyApiFactory();
  try {
    const res = await fp.v1PrivacyPolicyConsentGet({
      withCredentials: true,
    });
    return { success: true, is_agreed: res.data.is_agreed, policy: res.data.policy ?? null };
  } catch (e) {
    if (e.response?.status === 401) {
      return { success: false, error: "画面をリロードし、再度ログインしてください" };
    }
    return { success: false, error: "ネットワークエラーです。しばらくたってからお試しください" };
  }
};

type PostConsentResponse = {
  success: boolean;
  status: number | null;
  error: string;
};

export const postPrivacyPolicyConsent = async (
  status: PrivacyPolicyConsentStatusEnum,
  privacyPolicyId: number
): Promise<PostConsentResponse> => {
  const fp = PropallyApiFactory();
  try {
    await fp.v1PrivacyPolicyConsentPost(
      { status, privacy_policy_id: privacyPolicyId },
      { withCredentials: true }
    );
    return { success: true, status: 204, error: "" };
  } catch (e) {
    if (e.response?.status === 401) {
      return { success: false, status: 401, error: "画面をリロードし、再度ログインしてください" };
    }
    if (e.response?.status === 400) {
      return { success: false, status: 400, error: "プライバシーポリシーが更新されました。内容をご確認ください" };
    }
    return {
      success: false,
      status: e.response?.status ?? null,
      error: "ネットワークエラーです。しばらくたってからお試しください",
    };
  }
};
